import { useFieldArray } from "react-hook-form";

export const useCampaignFormFields = (form) => {
  const { fields, append, remove, move } = useFieldArray({
    control: form.control,
    name: "formFields",
  });

  const addFormField = (type = "text") => {
    const currentFields = form.getValues("formFields") || [];
    const newOrder =
      (currentFields.length > 0
        ? Math.max(...currentFields.map((f) => f.order || 0))
        : 0) + 1;

    append({
      id: `field_${Date.now()}`,
      label: "",
      type,
      required: false,
      options: [],
      order: newOrder,
    });
  };

  const removeField = (index) => {
    remove(index);
  };

  const updateFieldOrder = (oldIndex, newIndex) => {
    const currentFields = form.getValues("formFields") || [];
    const updatedFields = [...currentFields];
    updatedFields.forEach((field, index) => {
      field.order = index;
    });
    form.setValue("formFields", updatedFields);
    move(oldIndex, newIndex);
  };

  return {
    fields,
    addFormField,
    removeField,
    updateFieldOrder,
  };
};
